// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { GetCmsLibraryApiParameter } from "@store/Framework/Services/CmsLibraryService";
import CmsLibraryState from "@store/Framework/Store/Store/Data/CmsLibrary/CmsLibraryState";
import { SetLibraryFilterNavIsOpenParameter } from "@store/Framework/Store/Store/Data/CmsLibrary/Handlers/SetLibraryFilterNavIsOpen";
import { CmsLibraryModel } from "@store/Framework/Types/ApiModels";
import { Draft } from "immer";

const initialState: CmsLibraryState = {
    libraries: {},
    isLoading: false,
    currentLibrary: "",
    parameters: {
        libraryType: "",
    },
    isFilterNavOpen: false,
};

const actions = {
    "Data/CmsLibrary/BeginLoadCmsLibrary": (draft: Draft<CmsLibraryState>) => {
        draft.isLoading = true;
    },
    "Data/CmsLibrary/CompleteLoadCmsLibrary": (
        draft: Draft<CmsLibraryState>,
        actions: { result?: CmsLibraryModel; currentType?: string },
    ) => {
        if (actions.result) {
            draft.libraries[actions.result.libraryType.toLowerCase()] = actions.result;
        }

        if (actions.currentType) {
            draft.currentLibrary = actions.currentType.toLowerCase();
        }

        draft.isLoading = false;
    },
    "Data/CmsLibrary/UpdateCmsLibraryParameters": (
        draft: Draft<CmsLibraryState>,
        actions: { parameter: GetCmsLibraryApiParameter },
    ) => {
        draft.parameters = {
            ...draft.parameters,
            ...actions.parameter,
        };
    },
    "Data/CmsLibrary/SetIsFilterNavOpen": (
        draft: Draft<CmsLibraryState>,
        action: SetLibraryFilterNavIsOpenParameter,
    ) => {
        draft.isFilterNavOpen = action.isOpen;
    },
    "Data/CmsLibrary/ResetParameters": (draft: Draft<CmsLibraryState>) => {
        draft.parameters = initialState.parameters;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type CmsLibraryDataActions = Parameters<typeof reducer>[1];
export default reducer;
